<template>
    <div class="message-bar mdl-cell mdl-cell--6-col mdl-cell--3-offset-desktop mdl-cell--1-offset-tablet mdl-shadow--4dp"
         v-bind:class="{'mdl-color--amber-600':isWarning, 'mdl-color--grey-600':isInfo, 'mdl-color--green-600':isSuccess}">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: "MessageBar",
        props: {
            type: {
                type: String,
                required: true
            },

        },
        computed: {
            isWarning() {
                return this.type === "warning"
            },
            isInfo() {
                return this.type === "info"
            },
            isSuccess() {
                return this.type === "success"
            }
        }
    }
</script>

<style scoped>
    .message-bar {
        border-radius: 1rem;
        text-align: center;
        color: white;
        padding: 1rem 1rem;
        font-size: 1.2em;
        font-weight: 300;
    }
</style>